import React, { useCallback } from 'react';
import { Flex, Pane, Text } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import { Toolbar } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.views.NoChartDataView');
export default function NoChartDataView(props) {
  const {
    relationship: {
      blueprint,
      attribute,
      path
    },
    objectType,
    client = 'AggsXYChartDataViewer'
  } = props;
  const resolveTranslation = useCallback((key, dVal, isIcon = false) => {
    const getFunc = isIcon ? 'getIcon' : 'getString';
    return attribute?.[getFunc]?.(key) || blueprint?.[getFunc]?.(key) || dVal;
  }, [attribute, blueprint]);
  const noChartDataTitle = resolveTranslation('noChartDataTitle', Config.get(client, 'noChartDataTitle', t('noChartDataTitle')));
  const noChartDataBody = resolveTranslation('noChartDataBody', Config.get(client, 'noChartDataBody', t('noChartDataBody')));
  const docLink = resolveTranslation('noChartDataDocLink', Config.get(client, 'noChartDataDocLink'));
  return /*#__PURE__*/_jsx(Pane, {
    variant: "noChartDataBody|noDataBody",
    layout: "flex:colXL",
    children: /*#__PURE__*/_jsxs(Flex, {
      variant: "colXL",
      justify: "center",
      vFill: true,
      children: [/*#__PURE__*/_jsxs(Pane, {
        variant: "noChartDataContent|noDataContent",
        layout: "flex:colL",
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "sectionTitle",
          children: noChartDataTitle
        }), /*#__PURE__*/_jsx(Text, {
          variant: "sectionBody",
          children: noChartDataBody
        }), docLink ? /*#__PURE__*/_jsx("a", {
          style: {
            textDecoration: 'none'
          },
          target: "blank",
          href: docLink,
          children: /*#__PURE__*/_jsx(Text, {
            variant: "link",
            children: t('documentation')
          })
        }) : null]
      }), /*#__PURE__*/_jsx(Toolbar, {
        matchContext: {
          client,
          use: 'noChartData',
          objectType,
          path
        },
        context: {
          clientProps: props
        },
        hasContextMenu: false,
        prefer: "text",
        variant: "noChartData"
      })]
    })
  });
}